import OperationDetails from './OperationDetails';

export default OperationDetails;
